import { EntityIdentifierHelper, EntityName } from '@fairandsmart/types';
import { FlexIndexableEntity, FlexIndexDocument } from './flex-search.service';

export class FlexIndexDocumentHelper {
  static from(entity: FlexIndexableEntity): FlexIndexDocument {
    const d: FlexIndexDocument = {
      id: entity.entityId,
      eN: entity.entityName,
      mD: entity.modificationDate,
      ref: entity.reference,
    };
    if (entity.entityName === EntityName.DATA) {
      d.dF = entity.format;
    }
    const connectionRef = entity.tags.find((t) => t.startsWith('connection:'));
    if (connectionRef != null) {
      d.cRef = connectionRef;
    }
    const requestRef = EntityIdentifierHelper.isOfType(entity.reference, EntityName.REQUEST)
      ? entity.reference
      : entity.tags.find((t) => t.startsWith('request:'));
    if (requestRef != null) {
      d.rRef = requestRef;
    }
    return d;
  }
}
